/** Shared Monaco themes — same as RequestBuilder CodeEditor (custom-light / custom-dark). */

export const MONACO_THEME_LIGHT = 'custom-light';
export const MONACO_THEME_DARK = 'custom-dark';

export const MONACO_EDITOR_COLORS = {
  light: { background: '#ffffff', foreground: '#333333' },
  dark: { background: '#161618', foreground: '#e5e7eb' },
};

let themesRegistered = false;

export function registerMonacoThemes(monaco) {
  if (themesRegistered) return;
  themesRegistered = true;

  monaco.editor.defineTheme(MONACO_THEME_LIGHT, {
    base: 'vs',
    inherit: true,
    // Response Hex view (see registerHexLanguage). The OFFSET is the column you
    // navigate by, so it is the one that gets colour; the ASCII gutter reads as
    // secondary, and bytes stay the default foreground so the dump does not
    // turn into a rainbow.
    rules: [
      { token: 'hex-offset', foreground: '6d28d9', fontStyle: 'bold' },
      { token: 'hex-ascii', foreground: '9ca3af' },
      { token: 'hex-note', foreground: '9ca3af', fontStyle: 'italic' },
    ],
    colors: {
      'editor.background': MONACO_EDITOR_COLORS.light.background,
      'editor.foreground': MONACO_EDITOR_COLORS.light.foreground,
      'editor.lineHighlightBackground': '#f8f9fa',
      'editor.selectionBackground': '#c8ccd499',
      'editor.inactiveSelectionBackground': '#c8ccd455',
      'editor.selectionHighlightBackground': '#94a3b833',
      'editor.wordHighlightBackground': '#64748b22',
      'editor.wordHighlightStrongBackground': '#64748b38',
      'editor.findMatchHighlightBackground': '#94a3b844',
      'editorLineNumber.foreground': '#999999',
      'editorGutter.background': MONACO_EDITOR_COLORS.light.background,
    },
  });

  monaco.editor.defineTheme(MONACO_THEME_DARK, {
    base: 'vs-dark',
    inherit: true,
    rules: [
      { token: 'hex-offset', foreground: 'a78bfa', fontStyle: 'bold' },
      { token: 'hex-ascii', foreground: '71717a' },
      { token: 'hex-note', foreground: '71717a', fontStyle: 'italic' },
    ],
    colors: {
      'editor.background': MONACO_EDITOR_COLORS.dark.background,
      'editor.foreground': MONACO_EDITOR_COLORS.dark.foreground,
      'editor.lineHighlightBackground': '#1f1f24',
      'editor.selectionBackground': '#ffffff45',
      'editor.inactiveSelectionBackground': '#ffffff28',
      'editor.selectionHighlightBackground': '#ffffff16',
      'editor.wordHighlightBackground': '#ffffff10',
      'editor.wordHighlightStrongBackground': '#ffffff1c',
      'editor.findMatchHighlightBackground': '#ffffff22',
      'editorLineNumber.foreground': '#6b7280',
      'editorGutter.background': MONACO_EDITOR_COLORS.dark.background,
      'editorStickyScroll.background': MONACO_EDITOR_COLORS.dark.background,
      'editorStickyScroll.border': '#ffffff22',
      'editorStickyScroll.shadow': '#00000055',
      'editorStickyScrollHover.background': '#2e2e36',
    },
  });
}

export function resolveMonacoTheme(isDark) {
  return isDark ? MONACO_THEME_DARK : MONACO_THEME_LIGHT;
}
